import React from 'react';
import {
  COMMAND_CENTER_AUTOPUBLISH_STAGE2_COPY,
  COMMAND_CENTER_BUNDLE_LANE_LABELS,
  COMMAND_CENTER_BUNDLE_TITLE,
  commandCenterBundleLaneStatusLabel,
} from '../../commandCenterCopy';
import type { LscAutomationActivationPayload } from '../../types';

export interface CommandCenterAutomationBundleCardProps {
  activation: LscAutomationActivationPayload | null;
  loading?: boolean;
}

const CommandCenterAutomationBundleCard: React.FC<CommandCenterAutomationBundleCardProps> = ({
  activation,
  loading = false,
}) => {
  if (loading && !activation) {
    return null;
  }

  if (!activation) {
    return null;
  }

  const bundleLanes = activation.bundle_lanes ?? [];

  return (
    <div
      className="rounded-xl border border-secondary-700 bg-secondary-900/40 px-4 py-4 space-y-3"
      data-testid="command-center-automation-bundle-card"
    >
      <div>
        <p className="text-xs uppercase tracking-wide text-secondary-500">{COMMAND_CENTER_BUNDLE_TITLE}</p>
        <p className="text-sm text-secondary-400 mt-1">
          Included when you activate the default customer bundle.
        </p>
      </div>
      <ul className="space-y-2">
        {bundleLanes.map((lane) => (
          <li
            key={lane.lane_key}
            className="flex items-start justify-between gap-3 text-sm"
            data-testid={`command-center-bundle-lane-${lane.lane_key}`}
          >
            <div>
              <p className="font-medium text-secondary-100">
                {COMMAND_CENTER_BUNDLE_LANE_LABELS[lane.lane_key] ?? lane.label}
              </p>
              {lane.lane_key === 'archive_autopublish' ? (
                <p className="text-xs text-secondary-500 mt-0.5">{COMMAND_CENTER_AUTOPUBLISH_STAGE2_COPY}</p>
              ) : lane.description ? (
                <p className="text-xs text-secondary-500 mt-0.5">{lane.description}</p>
              ) : null}
            </div>
            <span className="text-xs text-secondary-400 shrink-0">
              {lane.included_in_bundle
                ? commandCenterBundleLaneStatusLabel(lane.status)
                : 'Off'}
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default CommandCenterAutomationBundleCard;
